export enum ProjectRouteNames {
  PREFIX = '/',
  ALL = '*',
  APPLICATION = '/:branchId/*',
  SURVEY = 'survey',
  ADMIN = 'sy/yonetim',
  COMMON = 'common',
  LOGIN = 'login',
  REGISTER = 'register',
  RESET_PASSWORD = 'reset-password',
  PAYMENT_ERROR = 'sy/yonetim/payment/error',
  PAYMENT_SUCCESS = 'sy/yonetim/payment/success',
}
